// This file exports customized blocks for Blockly labs.

import {blocks as commonBlocks} from './commonBlocks';
import {blocks as playlabBlocks} from './playlabBlocks';

export default {
  ...commonBlocks,
  ...playlabBlocks,
};
